import React, { useMemo } from "react";

import { orderBy } from "lodash";

import useGetPortfolioFamilies from "@fartherfinance/frontend/api/Investment/hooks/useGetPortfolioFamilies";
import { PortfolioFamilyId } from "@fartherfinance/frontend/api/Investment/types";

import useAdvisorRequestAuth from "@src/multiCustodian/hooks/useAdvisorRequestAuth";
import useRequestAuth from "@src/multiCustodian/hooks/useRequestAuth";
import { DropdownMenuOption } from "@src/sharedComponents/CustomDropdownBase/MenuOptionsWithCheckIfSelected/MenuOptionsWithCheckIfSelected";
import BaseDropdown from "@src/sharedComponents/Dropdown/BaseDropdown";

import { categorizeProviderOptions, customOptions } from "./dataHelpers";

type PropsProvider = {
  label?: string;
  id?: string;
  onSelect: (el: DropdownMenuOption<PortfolioFamilyId>) => void;
  height: number;
};

const ProviderDropdown = (props: PropsProvider) => {
  const clientAuth = useRequestAuth();
  const advisorAuth = useAdvisorRequestAuth();

  const auth = clientAuth ?? advisorAuth;

  const portfolioFamilies = useGetPortfolioFamilies({ pageSize: "100" }, auth);

  const [portfolioFamiliesExceptFAMOptions, famOption] = useMemo(() => {
    if (portfolioFamilies.isLoading || portfolioFamilies.hasError) {
      return [[], []];
    }

    return categorizeProviderOptions(portfolioFamilies.data);
  }, [portfolioFamilies]);

  const providerOptions = useMemo(() => {
    if (portfolioFamilies.data === undefined) {
      return [];
    }
    return [
      {
        category: "Farther",
        options: orderBy(famOption, [(x) => x.label], ["asc"]),
      },
      {
        category: "Farther Model Marketplace",
        options: orderBy(
          portfolioFamiliesExceptFAMOptions,
          [(x) => x.label],
          ["asc"]
        ),
      },
      {
        category: "Custom Portfolios",
        options: customOptions,
      },
    ];
  }, [famOption, portfolioFamiliesExceptFAMOptions, portfolioFamilies.data]);

  return (
    <BaseDropdown
      title={"Asset Management Firm"}
      curItemLabel={props?.label}
      curItemId={props?.id}
      categoryWithOptions={providerOptions}
      onSelect={props.onSelect}
      height={props.height}
    />
  );
};

export default ProviderDropdown;
